<template>
  <el-row v-if="canEdit">
    <el-form ref="form" :rules="rules" :model="form" :label-width="labelWidth" :label-position="labelPosition">
      <slot>
        <template v-for="(item, index) in formTemplate">
          <el-col v-if="showBy(item)" :key="index" :md="item.col" :sm="24">

            <el-alert v-if="item.type != 'tips' && item.tips" :title="item.label + ' : ' + item.tips"
                      type="warning"></el-alert>

            <div v-if="item.type=='tips'" class="form-group-title"><span
              class="ogc-icon-font ogc-icon-fangkuaizuhe"></span> {{ item.tips }}
            </div>

            <el-form-item v-else-if="item.type=='display'" :label="item.label" :prop="item.prop">
              {{ form[item.prop] }}
            </el-form-item>

            <el-form-item v-else-if="item.type=='captcha'" :label="item.label" :prop="item.prop">
              <el-input placeholder="请输入验证码" v-model="form[item.prop]" class="v-code-input"
                        :clearable="true"></el-input>
              <img :src="'data:image/png;base64,'+captchaUrlImg" alt="" class="v-code" @click="refreshCaptcha">
              <!--              <img :src="captchaFullUrl" alt="" class="v-code" @click="refreshCaptcha">-->
            </el-form-item>

            <el-form-item v-else-if="item.type=='v-code'" :label="item.label" :prop="item.prop">
              <el-input placeholder="请输入短信验证码" v-model="form[item.prop]" class="v-code-input"
                        :clearable="true"></el-input>
              <el-button alt="" class="v-code" @click="() => { item.click(sendVCode) }" :disabled="sendVCodeTime > 0">
                {{ sendVCodeTime > 0 ? sendVCodeTime + " 秒" : "发送验证码" }}
              </el-button>
            </el-form-item>

            <el-form-item v-else-if="item.type=='select'" :label="item.label" :prop="item.prop">
              <el-select v-model="form[item.prop]" :placeholder="'请选择' + item.label" style="width: 100%"
                         :disabled="item.cannotEidt && isEdit" :filterable="item.filterable"
                         @change="(vals) => { if(item.change != undefined) item.change(vals) }">
                <el-option v-for="(option, jndex) in item.options" :key="jndex" :label="option.label"
                           :value="option.value"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item v-else-if="item.type=='select-multiple'" :label="item.label" :prop="item.prop">
              <el-select v-model="form[item.prop]" multiple :placeholder="'请选择' + item.label" style="width: 100%"
                         :disabled="item.cannotEidt && isEdit" :filterable="item.filterable"
                         @change="(vals) => { if(item.change != undefined) item.change(vals) }">
                <el-option v-for="(option, jndex) in item.options" :key="jndex" :label="option.label"
                           :value="option.value"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item v-else-if="item.type=='allow-create-select'" :label="item.label" :prop="item.prop">
              <el-select v-model="form[item.prop]" :placeholder="'请选择' + item.label" style="width: 100%"
                         :disabled="item.cannotEidt && isEdit"
                         filterable allow-create default-first-option
                         @change="(vals) => { if(item.change != undefined) item.change(vals) }">
                <el-option v-for="(option, jndex) in item.options" :key="jndex" :label="option.label"
                           :value="option.value"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item v-else-if="item.type=='select-group'" :label="item.label" :prop="item.prop">
              <el-select v-model="form[item.prop]" :placeholder="'请选择' + item.label" style="width: 100%"
                         :disabled="item.cannotEidt && isEdit">
                <template v-if="item.options.length == 1">
                  <el-option v-for="(option, jndex) in item.options[0].children" :key="jndex" :label="option.label"
                             :value="option.value"></el-option>
                </template>
                <template v-else-if="item.options.length > 1">
                  <el-option-group v-for="(group, jndex) in item.options" :key="jndex" :label="group.label">
                    <el-option v-for="item in group.children" :key="item.value" :label="item.label"
                               :value="item.value"></el-option>
                  </el-option-group>
                </template>
              </el-select>
            </el-form-item>

            <el-form-item v-else-if="item.type=='radio'" :label="item.label" :prop="item.prop">
              <el-radio-group v-model="form[item.prop]" :disabled="item.cannotEidt && isEdit" @change="(vals) => { if(item.change != undefined) item.change(vals) }">
                <el-radio-button v-for="(option, jndex) in item.options" :key="jndex" :label="option.value">
                  {{ option.label }}
                </el-radio-button>
              </el-radio-group>
            </el-form-item>

            <el-form-item v-else-if="item.type=='checkbox'" :label="item.label" :prop="item.prop">
              <el-checkbox-group v-model="form[item.prop]" :disabled="item.cannotEidt && isEdit">
                <el-checkbox v-for="(option, jndex) in item.options" :key="jndex" :label="option.value" border>
                  {{ option.label }}
                </el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <el-form-item v-else-if="item.type=='picture-list'" :label="item.label" :prop="item.prop">
              <picture-list v-model.trim="form[item.prop]" :type="item.pictureType" :id="form[item.formIdProp]"
                            :limit="item.limit"></picture-list>
            </el-form-item>
            <el-form-item v-else-if="item.type=='pictureBase'" :label="item.label" :prop="item.prop">
              <picture-listBase v-model.trim="form[item.prop]" :type="item.pictureType" :id="form[item.formIdProp]"
                            :limit="item.limit"></picture-listBase>
            </el-form-item>
            <el-form-item v-else-if="item.type=='date'" :label="item.label" :prop="item.prop">
              <el-date-picker v-model="form[item.prop]" type="date" :placeholder="'请选择' + item.label"
                              :disabled="item.cannotEidt && isEdit" value-format="yyyy-MM-dd"
                              style="width: 100%"></el-date-picker>
            </el-form-item>

            <el-form-item v-else-if="item.type=='textarea'" :label="item.label" :prop="item.prop">
              <el-input type="textarea" v-model.trim="form[item.prop]" :placeholder="'请输入' + item.label"
                        :clearable="!item.disclearable"></el-input>
            </el-form-item>

            <el-form-item v-else-if="item.type=='transfer'" :label="item.label" :prop="item.prop">
              <el-transfer v-model="form[item.prop]"
                           :data="form[item.optionProp] == undefined ? item.data : form[item.optionProp]"
                           :filterable="item.filterable" :titles="item.titles"
                           :button-texts="item.buttons"></el-transfer>
            </el-form-item>

            <el-form-item v-else-if="item.type=='number'" :label="item.label" :prop="item.prop">
              <el-input v-model="form[item.prop]" :placeholder="'请输入' + item.label" :clearable="!item.disclearable"
                        oninput="if(isNaN(value)) { value = null } if(value.indexOf('.')>0){value=value.slice(0,value.indexOf('.')+3)}">
                <template v-if="item.append" slot="append">
                  {{ form[item.append] != undefined ? form[item.append] : item.append }}
                </template>
              </el-input>
            </el-form-item>

            <el-form-item v-else-if="item.type=='number-adjustment'" :label="item.label" :prop="item.prop">
              <el-input v-model="form[item.prop]" :placeholder="'请输入' + item.label" :clearable="!item.disclearable"
                        oninput="if(isNaN(value)) { value = null } if(value.indexOf('.')>0){value=value.slice(0,value.indexOf('.')+3)}">
                <el-select v-model="form[item.optionProp]" slot="prepend" style="width:80px; text-align: center">
                  <el-option label="增加" :value="1"></el-option>
                  <el-option label="减少" :value="-1"></el-option>
                </el-select>

                <template slot="append">{{ item.append }}</template>
              </el-input>
            </el-form-item>

            <el-form-item v-else-if="item.type=='user-no'" :label="item.label" :prop="item.prop">
              <el-input v-model="form[item.prop]" :placeholder="'请输入' + item.label" :clearable="!item.disclearable"
                        :disabled="item.cannotEidt && isEdit"
                        @change="(vals) => { if(item.change != undefined) item.change(vals) }">
                <el-select v-model="form[item.optionProp]" slot="prepend" style="width:120px; text-align: center"
                           :disabled="item.cannotEidt && isEdit"
                           @change="(vals) => { if(item.selectShange != undefined) item.selectShange(vals) }">
                  <el-option label="身份证" :value="0"></el-option>
                  <el-option label="护照" :value="1"></el-option>
                  <el-option label="军人证" :value="2"></el-option>
                  <el-option label="港澳通行证" :value="9"></el-option>
                </el-select>
              </el-input>
            </el-form-item>

            <el-form-item v-else-if="item.type=='password'" :label="item.label" :prop="item.prop">
              <el-input v-model.trim="form[item.prop]" type="password" :placeholder="'请输入' + item.label"
                        :clearable="!item.disclearable" :disabled="item.cannotEidt && isEdit">
              </el-input>
            </el-form-item>

            <el-form-item v-else :label="item.label" :prop="item.prop">
              <el-input v-model.trim="form[item.prop]" :placeholder="'请输入' + item.label" :clearable="!item.disclearable"
                        :disabled="item.cannotEidt && isEdit"
                        @blur="(vals)=> {if(item.blur != undefined)item.blur(vals)}"
                        @change="(vals) => { if(item.change != undefined) item.change(vals) }">
                <template v-if="item.append" slot="append">
                  {{ form[item.append] != undefined ? form[item.append] : item.append }}
                </template>
                <template v-else-if="item.appendbutton" slot="append">
                  <el-button @click="item.click">{{ item.appendbutton }}</el-button>
                </template>
              </el-input>
            </el-form-item>
          </el-col>
        </template>
      </slot>
    </el-form>
  </el-row>

  <div v-else>
    <template v-for="(item, index) in formTemplate">
      <el-row :key="index" v-if="item.type=='tips'">
        <el-col :span="24">
          <div class="form-group-title"><span class="fa fa-pencil-square-o"></span> {{ item.tips }}</div>
        </el-col>
      </el-row>
      <el-row :key="index" v-else class="display-row">
        <template v-if="showBy(item)">
          <el-col :span="4" class="display-label">{{ item.label }} :</el-col>
          <el-col :span="item.col - 4" v-if="form[item.prop] === null || form[item.prop] === ''">&nbsp;</el-col>
          <el-col :span="item.col - 4" v-else-if="item.type=='select' || item.type=='radio'">
            {{ isnull(search(item.options, 'value', form[item.prop], 'label'), '&nbsp;') }}
          </el-col>
          <el-col :span="item.col - 4" v-else-if="item.type=='select-multiple'">
            {{ isnull(search(item.options, 'value', form[item.prop], 'label'), '&nbsp;') }}
          </el-col>
          <el-col :span="item.col - 4" v-else-if="item.type=='select-group'">
            {{ isnull(searchGroup(item.options, 'value', form[item.prop], 'label'), '&nbsp;') }}
          </el-col>
          <el-col :span="item.col - 4" v-else-if="item.type=='date'">
            {{ isnull(showDate(form[item.prop]), '&nbsp;') }}
          </el-col>
          <el-col :span="item.col - 4" v-else-if="item.type=='transfer'">
            {{
              isnull(searchTransfer(form[item.optionProp] === undefined ? item.data : form[item.optionProp], 'key', form[item.prop], 'label'), '&nbsp;')
            }}
          </el-col>
          <el-col :span="item.col - 4" v-else-if="item.type=='richtext'">
            <div v-if="form[item.prop]" v-html="form[item.prop]" class="richtext"></div>
            <div v-else>暂无数据</div>
          </el-col>
          <el-col :span="item.col - 4" v-else-if="item.type=='picture-list'">
            <div class="picture-group">
              <el-image v-for="(pic, jndex) in initPictureList(form[item.prop], item.prop)" :key="jndex"
                        style="width: 130px; height: 130px" :src="pic"
                        :preview-src-list="previewPictures(pic, pictures[item.prop])"></el-image>
              <div v-if="form[item.prop] === null || form[item.prop].length == 0">暂未上传图片</div>
            </div>
          </el-col>
          <el-col :span="item.col - 4" v-else-if="item.type=='pictureBase'">
            <div class="picture-group">
              <el-image v-for="(pic, jndex) in initPictureListBase(form[item.prop], item.prop)" :key="jndex"
                        style="width: 130px; height: 130px" :src="pic"
                        :preview-src-list="previewPicturesBase(pic, pictures[item.prop])"></el-image>
              <div v-if="form[item.prop] === null || form[item.prop].length == 0">暂未上传图片</div>
            </div>
          </el-col>
          <el-col :span="item.col - 4" v-else-if="item.type=='picture'">
            <div class="picture-group">
              <el-image style="width: 180px;" :src="initPicture(form[item.prop])"
                        :preview-src-list="[initPicture(form[item.prop])]"></el-image>
              <div v-if="form[item.prop] === null || form[item.prop].length == 0">暂未上传图片</div>
            </div>
          </el-col>
          <el-col :span="item.col - 4" v-else>
            {{ form[item.prop] }} <span v-if="item.append !== undefined">{{
              form[item.append] !== undefined ? form[item.append] : item.append
            }}</span>
          </el-col>
        </template>
      </el-row>
    </template>
  </div>

</template>

<script type="text/javascript">
import PictureList from '@/components/PictureList/PictureList'
import PictureListBase from '@/components/PictureList/PictureListBase'

export default {
  components: {PictureList,PictureListBase},
  props: {
    labelWidth: {
      type: String,
      default: '130px'
    },
    rules: {
      type: Object
    },
    form: {
      type: Object
    },
    url: {
      type: String
    },
    labelPosition:{
      type: String,
      default: 'right'
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    canEdit: {
      type: Boolean,
      default: true
    },
    formTemplate: {
      type: Array | Object,
      default: () => []
    }
  },
  data() {
    return {
      first: true,
      captchaUrl: SZH.assets.api + '/Login/GetAuthCode',
      captchaUrlTails: 'feelingscoder',
      sendVCodeTime: 0,
      captchaUrlImg: '',
      pictures: {},
    }
  },
  methods: {
    isnull(val, def) {
      return val === null || val == '' ? def : val;
    },
    showBy(item) {
      var can = item.showByProp === undefined;

      if (typeof (item.showByProp) == 'string') {
        can = can ||
          (
            item.showValue !== undefined &&
            this.form[item.showByProp] == item.showValue ||
            item.showValue === undefined &&
            this.form[item.showByProp] !== null &&
            this.form[item.showByProp] !== ''
          );
      } else if (typeof (item.showByProp) == 'object') {
        if (!can) {
          var tcan = true;
          for (var i in item.showByProp) {
            var t = item.showByProp[i];
            tcan = tcan && (
              t.value !== undefined && this.form[t.prop] == t.value ||
              t.value === undefined && this.form[t.prop] !== null && this.form[t.prop] !== ''
            )
          }
          can = tcan;
        }
      }

      return can;
    },
    initPictureList(picList, item) {
      var list = [];
      for (var i in picList) {
        if (typeof (picList[i]) !== "function")
          list.push(SZH.assets.image + picList[i].Url);
      }
      this.pictures[item] = list;
      return list;
    },
    initPictureListBase(picList, item) {
      var list = [];
      for (var i in picList) {
        if (typeof (picList[i]) !== "function")
          list.push('data:image/jpg;base64,'+ picList[i].Url);
      }
      this.pictures[item] = list;
      return list;
    },
    previewPicturesBase(key, pics) {
      var pre = [];
      var result = [];
      var found = false;
      for (var i in pics) {
        if (typeof (pics[i]) !== "function") {
          if (pics[i] == key) {
            found = true;
          }
          if (!found) pre.push(pics[i]);
          else result.push(pics[i]);
        }
      }
      return result.concat(pre);
    },
    getPic() {
      let self = this;
      self.$http.get(self.captchaUrl, {

      }).then((response) => {
        self.captchaUrlImg = response
      })
        .catch((error) => {
          console.log(error);
        });
    },
    previewPictures(key, pics) {
      var pre = [];
      var result = [];
      var found = false;
      for (var i in pics) {
        if (typeof (pics[i]) !== "function") {
          if (pics[i] == key) {
            found = true;
          }
          if (!found) pre.push(pics[i]);
          else result.push(pics[i]);
        }
      }
      return result.concat(pre);
    },
    initForm() {
      if (this.formTemplate && this.formTemplate.length > 0) {
        for (var i in this.form) {
          this.form[i] = null;
          for (var j in this.formTemplate) {
            if (this.formTemplate[j].prop == i && this.formTemplate[j].default != undefined) {
              this.form[i] = this.formTemplate[j].default;
            } else if (this.formTemplate[j].optionProp == i && this.formTemplate[j].defaultOption != undefined) {
              this.form[i] = this.formTemplate[j].defaultOption;
            }
          }
        }
      }
      this.clearValidate();
    },
    refreshCaptcha() {
      this.getPic();
      // this.captchaUrlTails = Math.random();
    },
    clearValidate() {
      // 清除验证消息
      this.$nextTick(() => {
        if (this.$refs['form'] !== undefined) {
          this.$refs['form'].clearValidate()
        }
      });
    },
    submit() {
      let self = this;
      // 去掉 treeTable 生成的父子级对象
      self.form.parent = undefined;
      self.form.children = undefined;
      self.form.subs = undefined;
      // 提交数据
      self.$refs['form'].validate(valid => {
        if (valid) {
          self.$emit('beforeSave');
          self.uploading = true;
          self.$http.post(self.url, self.form).then(result => {
            if (result.state == true) {
              self.$emit('saved', result.data);
            } else {
              self.$message.error(result.message);
            }
            self.uploading = false;
            self.$emit('afterSaved');
          }, () => {
            self.uploading = false;
            self.$message.error('数据保存失败，请检查您的网络是否可用。');
            self.$emit('onSavedError')
          });
        } else {
          return false;
        }
      });
    },
    validate(func) {
      this.$refs['form'].validate(func);
    },
    validateField(field, func) {
      this.$refs['form'].validateField(field, func);
    },
    search(array, keyProp, key, prop) {
      var result = '';
      if (key === undefined || key === null || key == "") {
        result = '';
      } else if (typeof (key) == 'string' || typeof (key) == 'number' || typeof (key) == 'boolean') {
        for (var i in array) {
          if (array[i][keyProp] == key) {
            result += array[i][prop];
            break;
          }
        }
      } else {
        for (var i in array) {
          for (var j in key) {
            if (array[i][keyProp] == key[j]) {
              result += result == "" ? "" : ", ";
              result += array[i][prop];
              break;
            }
          }
        }
      }
      return result;
    },
    searchGroup(array, keyProp, key, prop) {
      var result = null;
      var find = false;
      for (var i in array) {
        for (var j in array[i].children) {
          if (array[i].children[j][keyProp] == key) {
            result = array[i].children[j][prop];
            find = true;
            break;
          }
        }
        if (find) break;
      }
      return result;
    },
    searchTransfer(array, keyProp, keys, prop) {
      var result = "[";
      var find = false;
      for (var j in keys) {
        var key = keys[j];
        if (result != "[") result += "], [";
        for (var i in array) {
          if (array[i][keyProp] == key) {
            result += array[i][prop];
            break;
          }
        }
      }
      result += "]";
      return result;
    },
    showDate(date) {
      return new Date(date).format("yyyy年MM月dd日")
    },
    sendVCode() {
      var me = this;
      me.sendVCodeTime = 60;

      localStorage.setItem("sendvcodetime", 60);

      let index = setInterval(() => {
        if (me.sendVCodeTime > 0) {
          localStorage.setItem("sendvcodetime", --me.sendVCodeTime);
        } else {
          clearInterval(index)
          localStorage.removeItem("sendvcodetime")
        }
      }, 1000);
    }
  },
  computed: {
    // captchaUrlImg() {
    //   return this.captchaUrl + "?tails=" + this.captchaUrlTails;
    // }
  },
  created() {
  },
  mounted() {
    this.getPic();
    var x = localStorage.getItem("sendvcodetime");
    if (x != null) {
      var i = parseInt(x);
      if (i > 0) {
        this.sendVCodeTime = i;
        var me = this;
        let index = setInterval(() => {
          if (me.sendVCodeTime > 0) {
            localStorage.setItem("sendvcodetime", --me.sendVCodeTime);
          } else {
            clearInterval(index)
            localStorage.removeItem("sendvcodetime")
          }
        }, 1000);
      }
    }
  },
  watch: {}
}
</script>

<style type="text/css" scoped>

.display-row {
  line-height: 40px;
}

.richtext {
  border: 1px solid #CCC;
}

.display-label {
  text-align: right;
  padding-right: 20px;
  font-weight: 700;
}

.v-code-input {
  width: calc(100% - 120px - 10px);
  display: inline-block;
}

.v-code {
  float: right;
  width: 120px;
  height: 40px;
}

</style>



// WEBPACK FOOTER //
// src/components/AutoForm.vue